import React from 'react';
import './style.scss';
import { isRTL } from '../../../services/userModel.js';
import classNames from 'classnames';
import {getTranslateTitle} from '../../../utils/objects-util.js';
import EditableTable from '../EditableTable/EditableTable.jsx';
import { connect } from 'react-redux';
import { feesTypes } from '../../../models/reconciliationsSettingsTemplateModel.js';
import i18n from 'i18next';
import { getInitModel } from '../../../services/initModels.js';
import { MODEL_TYPE } from '../../../utils/enums.js';
import {fixedNumber} from "../../../utils/math-util.js";

const sortFeesData = (item, parentModel) => {
  const { fees } = item || {};
  if (!fees) return [];
  const result = [];

  Object.keys(feesTypes).forEach(key => {
    let res = { Total: 0 };

    Object.keys(fees).forEach(feesKey => {
      if (feesKey.includes(key)) {
        res[feesKey.replace(key, '')] = fees[feesKey];
      }
    });

    // get data from parent model
    parentModel &&
      Object.keys(parentModel.fees).forEach(parentFeesKey => {
        if (parentFeesKey.includes(key)) {
          res['parent' + parentFeesKey.replace(key, '')] = parentModel.fees[parentFeesKey];
          res.Total += fees[parentFeesKey] ? parseFloat(fees[parentFeesKey] || 0) : parseFloat(parentModel.fees[parentFeesKey] || 0);
        }
      });

    res.type = key;
    res.title = i18n.t(feesTypes[key]);
    res.withResetIcon = !!parentModel;
    res.Total = fixedNumber(res.Total, 2);
    result.push(res);
  });

  return result;
};


const SectionItemReconciliationFeesTable = ({ item, column, onPropChange, isLoading, configurations, mergedModel }) => {
  const parentModel = getInitModel(MODEL_TYPE.reconciliationsSettingsTemplateModel, mergedModel);
  const handleMapValues = value => {
    const result = [];
    // eslint-disable-next-line
    value.values?.forEach(item =>
      Object.keys(item).forEach(key => {
        if (key === 'type' || key === 'title' || key === 'Total') return;
        result.push({ [item.type + key]: item[key] || null });
      })
    );
    const openObjects = result.reduce((mergedObj, obj) => {
      return { ...mergedObj, ...obj };
    }, {});
    onPropChange({ fees: openObjects });
  };

  return (
    <div className={classNames('sectionItemReconciliationFeesTable', { rlt: isRTL() })}>
      <table className={classNames('header')}>
        <tbody>
          <tr>
            {column?.columns?.map((column, index) => {
              return (
                <td
                  key={`headerItem-${column.title}-${index}`}
                  className={classNames('headerItem', {
                    centered: column.centered,
                  })}
                  style={{
                    width: column.width ? `${column.width}` : `auto`,
                    textAlign: column.textRight ? 'right' : '',
                  }}
                >
                  {getTranslateTitle(column.title)}
                  &nbsp;
                </td>
              );
            })}
          </tr>
        </tbody>
      </table>
      <EditableTable
        model={column}
        items={sortFeesData(item, parentModel || {fees: {}})}
        // isTranslationRtl={translationsLanguage === 'he' || translationsLanguage === 'ar'}
        isLoading={isLoading}
        onPropChange={handleMapValues}
      />
    </div>
  );
};

const mapStateToProps = state => {
  return {
    configurations: state.reconciliations?.data?.configurations,
    mergedModel: state.reconciliations?.data?.mergedModel,
    isLoading: state.sectionsWrapperData.isLoading,
  };
};

export default connect(mapStateToProps)(SectionItemReconciliationFeesTable);
